import { axiosWithToken } from "@/utils/axios";

class PaymentService {
  InitializePayment(transactionReference: string) {
    return axiosWithToken().post(
      `/payments/initialize/${transactionReference}`,
    );
  }

  InitializeWithdrawal(transactionReference: string, pin: string) {
    return axiosWithToken().post(
      `/payments/withdrawal/${transactionReference}`,
      { pin },
    );
  }
}

export default new PaymentService();
